// ModalStyle.js
import { styled } from '@mui/system';
import { Box, IconButton } from '@mui/material';

export const ModalOverlay = styled(Box)({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
    backdropFilter: 'blur(2px)',
    zIndex: 1000,
});

export const ModalContainer = styled(Box)({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#ffffff',
    padding: '24px 28px',
    zIndex: 1001,
    width: '90%',
    maxWidth: '600px',
    maxHeight: '80vh',
    borderRadius: '16px',
    boxShadow: '0 24px 48px rgba(15, 23, 42, 0.35)',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
});

export const ModalCloseButton = styled(IconButton)({
    position: 'absolute',
    top: 12,
    right: 12,
    backgroundColor: 'rgba(148, 163, 184, 0.16)',
    color: '#475569',
    '&:hover': {
        backgroundColor: 'rgba(148, 163, 184, 0.28)',
    },
});
